import clubRequest from "../axios";
import {
  MerchantCustomerNotifierPayload,
  NotifierCustomerNotifierType,
} from "./request";

const getAutoMessageConfig = async () =>
  (await clubRequest.merchantCustomerNotifierList()).data;

const changeAutoMessageConfig = async (
  command: MerchantCustomerNotifierPayload
) => (await clubRequest.merchantCustomerNotifierUpdate(command)).data;

const checkNotifierBalance = async (command: NotifierCustomerNotifierType) =>
  (
    await clubRequest.customerNotifierCheckBalanceList({
      notifierType: command,
    })
  ).data;

const autoMessageService = {
  getAutoMessageConfig,
  changeAutoMessageConfig,
  checkNotifierBalance,
};

export default autoMessageService;
